import { render, staticRenderFns } from "./SpmFunc.vue?vue&type=template&id=413ca866"
import script from "./SpmFunc.vue?vue&type=script&lang=js"
export * from "./SpmFunc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports